var map = {
	"./403.json": "./locales/cz/403.json",
	"./404.json": "./locales/cz/404.json",
	"./accessSettings.json": "./locales/cz/accessSettings.json",
	"./adverseEvents.json": "./locales/cz/adverseEvents.json",
	"./audit.json": "./locales/cz/audit.json",
	"./buttons.json": "./locales/cz/buttons.json",
	"./calculations.json": "./locales/cz/calculations.json",
	"./clients.json": "./locales/cz/clients.json",
	"./clinicalTrailsSettings.json": "./locales/cz/clinicalTrailsSettings.json",
	"./coa.json": "./locales/cz/coa.json",
	"./dashboard.json": "./locales/cz/dashboard.json",
	"./datatable.json": "./locales/cz/datatable.json",
	"./eqTypes.json": "./locales/cz/eqTypes.json",
	"./equipments.json": "./locales/cz/equipments.json",
	"./experiments.json": "./locales/cz/experiments.json",
	"./inventories.json": "./locales/cz/inventories.json",
	"./laboratories.json": "./locales/cz/laboratories.json",
	"./locations.json": "./locales/cz/locations.json",
	"./lookup.json": "./locales/cz/lookup.json",
	"./main.json": "./locales/cz/main.json",
	"./maintTypes.json": "./locales/cz/maintTypes.json",
	"./materialTypes.json": "./locales/cz/materialTypes.json",
	"./materials.json": "./locales/cz/materials.json",
	"./methods.json": "./locales/cz/methods.json",
	"./monitoringVisits.json": "./locales/cz/monitoringVisits.json",
	"./navbar.json": "./locales/cz/navbar.json",
	"./orders.json": "./locales/cz/orders.json",
	"./organisations.json": "./locales/cz/organisations.json",
	"./patients.json": "./locales/cz/patients.json",
	"./personel.json": "./locales/cz/personel.json",
	"./priceList.json": "./locales/cz/priceList.json",
	"./projects.json": "./locales/cz/projects.json",
	"./reagents.json": "./locales/cz/reagents.json",
	"./reports.json": "./locales/cz/reports.json",
	"./samples.json": "./locales/cz/samples.json",
	"./services.json": "./locales/cz/services.json",
	"./signin.json": "./locales/cz/signin.json",
	"./signup.json": "./locales/cz/signup.json",
	"./specifications.json": "./locales/cz/specifications.json",
	"./superscript.json": "./locales/cz/superscript.json",
	"./suppliers.json": "./locales/cz/suppliers.json",
	"./systemEmail.json": "./locales/cz/systemEmail.json",
	"./tasks.json": "./locales/cz/tasks.json",
	"./testPlans.json": "./locales/cz/testPlans.json",
	"./tests.json": "./locales/cz/tests.json",
	"./timetable.json": "./locales/cz/timetable.json",
	"./trainings.json": "./locales/cz/trainings.json",
	"./transactions.json": "./locales/cz/transactions.json",
	"./trialsManagement.json": "./locales/cz/trialsManagement.json",
	"./uom.json": "./locales/cz/uom.json",
	"./validation.json": "./locales/cz/validation.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./locales/cz sync recursive \\.(json)$";